import { motion } from "framer-motion";
import { Mail, Phone, MapPin, Linkedin, Download, ArrowUpRight } from "lucide-react";
import { CONTACT } from "../../lib/portfolioData";
import { Reveal } from "./Reveal";

const DETAILS = [
  { icon: Mail, label: "Email", value: CONTACT.email, href: `mailto:${CONTACT.email}`, id: "email" },
  { icon: Phone, label: "Phone", value: CONTACT.phone, href: `tel:${CONTACT.phone.replace(/\s/g, "")}`, id: "phone" },
  { icon: MapPin, label: "Location", value: CONTACT.location, href: null, id: "location" },
  { icon: Linkedin, label: "LinkedIn", value: "Connect on LinkedIn", href: CONTACT.linkedin, id: "linkedin" },
];

export const ContactFooter = () => (
  <footer id="contact" data-testid="contact-section" className="relative pt-28 md:pt-40 pb-12 overflow-hidden">
    <div className="absolute -bottom-40 left-1/2 -translate-x-1/2 w-[900px] h-[600px] spotlight pointer-events-none" />

    <div className="max-w-7xl mx-auto px-6 md:px-10 relative">
      <Reveal>
        <p className="overline mb-6">06 · Let&apos;s Talk</p>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-7xl tracking-tight leading-[1.05] max-w-4xl">
          Let&apos;s connect to build high-ticket sponsorships and optimize your{" "}
          <span className="text-accent italic">digital inventory</span> commercial strategy.
        </h2>
      </Reveal>

      <Reveal delay={0.2}>
        <div className="mt-12 flex flex-wrap gap-4">
          <a
            href={`mailto:${CONTACT.email}`}
            data-testid="footer-email-cta"
            className="group inline-flex items-center gap-2 px-8 py-4 rounded-full bg-accent text-[#04110b] font-medium hover:brightness-110 transition"
          >
            Start a Conversation
            <ArrowUpRight size={18} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
          <a
            href={CONTACT.resume}
            download
            data-testid="footer-resume-btn"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full border border-white/20 hover:border-accent hover:text-accent transition"
          >
            <Download size={18} /> Download Resume
          </a>
        </div>
      </Reveal>

      <div className="mt-20 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {DETAILS.map((d, i) => {
          const Icon = d.icon;
          const content = (
            <motion.div
              whileHover={{ y: -4 }}
              className="h-full rounded-2xl border border-white/10 bg-[#0a1220]/60 p-6 hover:border-accent/40 transition-colors"
            >
              <div className="w-10 h-10 rounded-lg bg-accent/10 flex items-center justify-center text-accent mb-4">
                <Icon size={18} />
              </div>
              <p className="text-xs uppercase tracking-widest text-[#94a3b8] mb-1">{d.label}</p>
              <p className="text-white break-words">{d.value}</p>
            </motion.div>
          );
          return (
            <Reveal key={d.id} delay={i * 0.08}>
              {d.href ? (
                <a
                  href={d.href}
                  target={d.id === "linkedin" ? "_blank" : undefined}
                  rel="noopener noreferrer"
                  data-testid={`contact-${d.id}`}
                  className="block h-full"
                >
                  {content}
                </a>
              ) : (
                <div data-testid={`contact-${d.id}`} className="h-full">{content}</div>
              )}
            </Reveal>
          );
        })}
      </div>

      <div className="mt-20 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="font-display text-lg">
          Rohan<span className="text-accent">.</span>Parihar
        </p>
        <p className="text-sm text-[#94a3b8]">Media Sales & Brand Partnerships · New Delhi, India</p>
        <p className="text-xs text-[#94a3b8]">© {new Date().getFullYear()} · All rights reserved</p>
      </div>
    </div>
  </footer>
);
